import FieldConfig from "../../../proto/field-config"
import FieldDependencies_TableCell from "./render/table/table-cell"
import ModelEntity from "../../../../model2/model-entity"
import {EntityType} from "../../../../gd/const/item"
import FieldDropdown from "../../dropdown/dropdown"

export default class FieldDependencies extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Dependencies"
        // this.icon               = 'i5-dependent'

        this.renderComponents.tableCell         = FieldDependencies_TableCell
    }

    canEdit(model: ModelEntity): boolean {
        switch (model.entityType) {
            case EntityType.TASK    : return true
            // case EntityType.EVENT   : return false
            // case EntityType.PROJECT : return false
        }

        return false
    }

    sortValue(value: any, model?: any) {
        const dependencies = value?.models || []
        return dependencies.length
    }
}
